<div id="theTeamForm" >
    <span *ngIf="title" class="mat-title">{{title}}</span>
    <div *ngIf="team" class="content pb-0 m-0" fusePerfectScrollbar>

        <form [formGroup]="teamForm">

            <div class="flex flex-row gap-1 items-start">
                <mat-form-field dense appearance="outline" floatLabel="always" class="flex-1">
                    <mat-label>Nombre</mat-label>
                    <mat-icon matSuffix class="secondary-text">group</mat-icon>
                    <input name="name" formControlName="name" matInput required>
                </mat-form-field>
            </div>

            
            <div class="flex flex-row items-start">
                <mat-form-field dense appearance="outline" class="flex-1">
                    <mat-label>Descripción</mat-label>
                    <textarea name="description" formControlName="description" matInput></textarea>
                </mat-form-field>
            </div>
            <!-- <div fxLayout="row" fxLayoutAlign="start start" > -->
                <!-- <material-dual-listbox #dualList [source]="allPermissions" [(destination)]="role.permissions"></material-dual-listbox> -->
                <div class="flex items-start w-full" >
                    <h3>Miembros:</h3>
                </div>
                <dual-list #dualList [source]="users" [(destination)]="team.members" key="id" 
                    display="name" [format]="format" height="200px"   ></dual-list>
            <!-- </div> -->
           

        </form>
        <div *ngIf="_systemService.canAction('adminTeams')" class="m-0 p-16 flex flex-row justify-end items-center">
            <button *ngIf="action !== 'edit'"
                    mat-button mat-raised-button color="accent" class="save-button"
                    class="save-button"
                    (click)="guardarTeam()"
                    [disabled]="teamForm.invalid"
                    aria-label="SAVE">
                Guardar
            </button>
        </div>
    </div>

    <div *ngIf="!team">
        <span>Debe seleccionar un equipo para modificar o presionar 'Nuevo' para crear un equipo nuevo</span>
    </div>

</div>
